import { render, staticRenderFns } from "./AnnotatedDoc.vue?vue&type=template&id=6146438a&scoped=true&"
import script from "./AnnotatedDoc.vue?vue&type=script&lang=js&"
export * from "./AnnotatedDoc.vue?vue&type=script&lang=js&"
import style0 from "./AnnotatedDoc.vue?vue&type=style&index=0&id=6146438a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6146438a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCardText,VIcon,VSpacer})
